<template>
  <div>
      <topTab :changeTabIndex='2'></topTab>
      <appletspage></appletspage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import appletspage from "@/components/applets/applets.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    appletspage,
    bottomMsg,
    topTab
  }
}
</script>
